import { Component, OnInit, ViewChild } from '@angular/core';
import { NewsletterManagementService } from '../newsletter-management.service';
import { INewsletterCategoryGroup } from '../interfaces/i-newsletter-category-group';
import { FREQUENCY_NAME } from '../constants/frequency-friendly-names';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { SectionHeaderComponent } from 'src/app/shared/standalone/components/section-header/section-header.component';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-newsletter-list',
  templateUrl: './newsletter-list.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    SectionHeaderComponent,
    RouterModule,
  ],
})
export class NewsletterListComponent implements OnInit {
  @ViewChild(MatAccordion) allNewsletter: MatAccordion;
  newsletterList$: Observable<INewsletterCategoryGroup[]>;
  frequencies = FREQUENCY_NAME;
  expandSite: string;
  constructor(
    private newsletterManagementService: NewsletterManagementService,
    private route: ActivatedRoute,
  ) {}
  ngOnInit(): void {
    this.expandSite = this.route.snapshot.queryParamMap.get('site');

    this.newsletterList$ =
      this.newsletterManagementService.getAllNewsletters$();
  }
}
